module.exports = __webpack_public_path__ + "static/media/cookedbatiliskwing.172808af.webp";